import { createSlice } from '@reduxjs/toolkit'

const filterKeys:any = ['page', 'limit', 'sortBy', 'sortOrder','value', 'url'];

const initialState:any = {};

filterKeys.forEach((item:any) => {
  initialState[item] = null;
});

const slice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilterState: (state: any, action) => {
      filterKeys.forEach((item: string) => {
        if (item in action.payload) state[item] = action?.payload[item] ?? null;
      });
      state['url'] = window.location.href;
    },
    resetFilterState: (state) => { 
      filterKeys.forEach((item: string) => {
        state[item] = null;
      })
    },
    resetFilter(state, action) {
      state = initialState
      return state
    }
  },
})

export const { setFilterState, resetFilterState , resetFilter} = slice.actions
export default slice.reducer
export const getFilterInfo = (state: any) => state?.filter